import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  { path: "/", name: "home", component: HomeView },
  { path: "/paketler", name: "packages", component: HomeView },
  { path: "/kurumsal-web", name: "corporate-web", component: HomeView },
  { path: "/eticaret", name: "ecommerce", component: HomeView },
  { path: "/crm", name: "crm", component: HomeView },
  { path: "/b2b", name: "b2b", component: HomeView },
  { path: "/mobil-uygulama", name: "mobile-app", component: HomeView },
  { path: "/sanal-pos", name: "pos-integration", component: HomeView },
  { path: "/muhasebe-entegrasyonu", name: "accounting-integration", component: HomeView },
  { path: "/alotech", name: "alotech", component: HomeView },
  { path: "/etkinlik-biletleme", name: "event-ticketing", component: HomeView },
  { path: "/ozel-erp", name: "custom-erp", component: HomeView },
  { path: "/abonelik", name: "subscription", component: HomeView },
  { path: "/hizmetler", name: "services", component: HomeView },
  { path: "/hakkimizda", name: "about", component: HomeView },
  { path: "/sss", name: "faq", component: HomeView },
  { path: "/rehber", name: "knowledge-guide", component: HomeView },
  { path: "/iletisim", name: "contact", component: HomeView },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    }
    const sectionMap = {
      "/paketler": "#paketler",
      "/kurumsal-web": "#paketler",
      "/eticaret": "#paketler",
      "/crm": "#paketler",
      "/b2b": "#paketler",
      "/mobil-uygulama": "#paketler",
      "/sanal-pos": "#paketler",
      "/muhasebe-entegrasyonu": "#paketler",
      "/alotech": "#hizmetler",
      "/etkinlik-biletleme": "#hizmetler",
      "/ozel-erp": "#hizmetler",
      "/abonelik": "#abonelik",
      "/hizmetler": "#hizmetler",
      "/hakkimizda": "#hakkimizda",
      "/sss": "#sss",
      "/rehber": "#rehber",
      "/iletisim": "#iletisim",
    };
    if (sectionMap[to.path]) {
      return { el: sectionMap[to.path], behavior: "smooth" };
    }
    return { top: 0 };
  },
});

export default router;
